import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import ProjectTitle from '@/components/ProjectTitle';
import Box from '@/atoms/Box';
import Heading from '@/atoms/Heading';

import { scale, media } from '@/styles/utils';
import theme from '@/styles/theme';
import { getUri } from '@/utils/routing';

const ProjectList = styled(Box)`
  list-style: none;
`;

const Project = styled(Heading)`
  padding-bottom: ${scale(1)};

  ${media.md`
    display: inline-block;
    line-height: 1.15;

    :not(:last-child)::after {
      display: inline-block;
      content: ' / ';
      padding: 0 0.4em;
    }
  `}
`;

const ProjectLink = styled(Link)`
  display: block;
  text-decoration: none;
  color: ${theme.color.black};
  transition: color 0.25s ease-out;

  &:hover,
  &:active,
  &:focus {
    color: ${theme.color.white};
  }

  ${media.md`
    display: inline;
  `}
`;

export default ({
  projects,
  setActiveProject,
  activeProject,
  isAutoplayAvailable,
  ...props
}) => {
  return (
    <ProjectList as="ul" {...props}>
      {projects.map(project => (
        <Project
          h={1}
          as="li"
          key={project.slug.current}
          onMouseEnter={() => {
            if (!('ontouchstart' in window) && navigator.maxTouchPoints < 1)
              // only on non-touch devices
              setActiveProject(project.id);
          }}
          onMouseLeave={() => setActiveProject(null)}
        >
          <ProjectLink
            to={getUri(project.slug.current, 'project')}
            onClick={e => {
              if (
                isAutoplayAvailable &&
                ('ontouchstart' in window || navigator.maxTouchPoints) &&
                activeProject !== project.id
              ) {
                e.preventDefault();

                setActiveProject(project.id);
              }
            }}
          >
            <ProjectTitle
              $display="inline"
              client={project.client.title}
              title={project.title}
              date={project.date}
              size={1}
              as="p"
            />
          </ProjectLink>
        </Project>
      ))}
    </ProjectList>
  );
};
